// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WorkStages-module--wrapper--V_k03"};